export default {
	required: 'Tieto vaaditaan',
	mapFirstPoint: 'Valitse kartalta aloituspiste',
	mapNextPoint: 'Valitse etappipiste (Huom! Välin, jonka kuljit samalla kulkuvälineellä)',
	mapFillEnded: 'Kartan alle on listattu matkaetappisi tiedot. Jatka seuraavaan kysymykseen Seuraava-painikkeesta',
}
